import { useState } from "react"
import _ from "lodash"

//PrimeReact Components
import { Button } from "primereact/button"
import { Badge } from "primereact/badge"

//Styles
import styles from "../../../../styles/kiosk/KioskActivityCheckInOptions.module.css"
import kioskStyles from "../../../../styles/kiosk/KioskAdmin.module.css"

//Kiosk components
import CustomTable from "../CustomComponents/CustomTable"

const ActivityCheckInDataTable = ({
  activityCheckInOptions,
  setEditOption,
  setShowModal,
  setDeleteOption,
  deleteOption,
}) => {
  const [firstExpandedRows, setFirstExpandedRows] = useState(null)
  const [secondExpandedRows, setSecondExpandedRows] = useState(null)

  const criteriaTemplate = (rowData) => {
    return (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {rowData?.criteria?.map((c) => {
          return <div className={styles.criteriaPills}>{c.description}</div>
        })}
      </div>
    )
  }
  const successMessageTemplate = (rowData) => {
    return <div className={styles.dataTableText}>{rowData?.successMessage}</div>
  }
  const failureMessageTemplate = (rowData) => {
    return <div className={styles.dataTableText}>{rowData?.failureMessage}</div>
  }
  const optionTemplate = (rowData) => {
    return <div className={styles.dataTableText}>{rowData?.name}</div>
  }
  const actionsTemplate = (rowData) => {
    if (rowData?.other) {
      return (
        <Badge
          value={"System option"}
          tooltip={"The Other option is a special system option"}
        />
      )
    }

    return (
      <>
        <Button
          icon="pi pi-pencil"
          className={`${kioskStyles.roundedButton} ${kioskStyles.editButton}`}
          tooltip="edit"
          type="button"
          onClick={() => {
            setEditOption(rowData)
            setShowModal(true)
          }}
          disabled={rowData?.other}
          tooltipOptions={{ position: "bottom", className: "custom-tooltip" }}
        />
        <Button
          icon="pi pi-trash"
          className={`${kioskStyles.roundedButton} ${kioskStyles.deleteButton}`}
          tooltip="delete"
          type="button"
          onClick={() => {
            setDeleteOption(true)
            setEditOption(rowData)
            setShowModal(true)
          }}
          disabled={rowData?.other}
          tooltipOptions={{ position: "bottom", className: "custom-tooltip" }}
        />
      </>
    )
  }

  const SecondCustomExpansionTemplate = (data) => {
    let expandedHeaders = headers().filter((header) => header.id !== "expander")

    return (
      <>
        <CustomTable
          collection={data.children}
          headers={expandedHeaders}
          dataKey="id"
        />
      </>
    )
  }

  const FirstCustomExpansionTemplate = (data) => {
    let expandedHeaders = headers().map((header) => {
      if (header.id === "expander") {
        return {
          ...header,
          dataTemplate: secondExpanderBodyTemplate,
        }
      }

      return header
    })

    return (
      <CustomTable
        collection={data.children}
        headers={expandedHeaders}
        expandedRows={secondExpandedRows}
        rowExpansionTemplate={SecondCustomExpansionTemplate}
        dataKey="id"
        wrapperClassName={styles.firstExpandedTableWrapper}
        dataTableClassName={styles.firstExpandedTable}
      />
    )
  }

  const isRowExpandable = (rowData) => rowData?.children?.length > 0

  const firstExpanderBodyTemplate = (rowData) => {
    if (!isRowExpandable(rowData)) {
      return null
    }
    return (
      <Button
        icon={!firstExpandedRows ? "pi pi-angle-right" : "pi pi-angle-down"}
        onClick={() => {
          const data = { [rowData?.id]: true }
          if (!firstExpandedRows) {
            setFirstExpandedRows(data)
          } else {
            setFirstExpandedRows(null)
          }
        }}
        className={styles.expandButton}
      />
    )
  }

  const secondExpanderBodyTemplate = (rowData) => {
    if (!isRowExpandable(rowData)) {
      return null
    }
    return (
      <Button
        icon={!secondExpandedRows ? "pi pi-angle-right" : "pi pi-angle-down"}
        onClick={() => {
          const data = { [rowData?.id]: true }
          if (!secondExpandedRows) {
            setSecondExpandedRows(data)
          } else {
            setSecondExpandedRows(null)
          }
        }}
        className={styles.expandButton}
      />
    )
  }

  function headers() {
    return [
      {
        id: "expander",
        value: "",
        label: "",
        dataTemplate: firstExpanderBodyTemplate,
        className: styles.CustomTableColExpander,
        expander: true,
        noSort: true,
      },
      {
        value: "name",
        label: "Option",
        dataTemplate: optionTemplate,
        className: styles.CustomTableColOption,
        noSort: true,
      },
      {
        value: "criteria",
        label: "Participant Status Eligibility",
        dataTemplate: criteriaTemplate,
        className: styles.CustomTableColParticipantStatus,
        noSort: true,
      },
      {
        value: "successMessage",
        label: "Success Message",
        dataTemplate: successMessageTemplate,
        className: styles.CustomTableColSuccessMessage,
        noSort: true,
      },
      {
        value: "failureMessage",
        label: "Failure Message",
        dataTemplate: failureMessageTemplate,
        className: styles.CustomTableColFailureMessage,
        noSort: true,
      },

      {
        id: "actions",
        value: "",
        label: undefined,
        dataTemplate: actionsTemplate,
        className: styles.CustomTableColActions,
        noSort: true,
      },
    ]
  }

  return (
    <CustomTable
      collection={activityCheckInOptions}
      headers={headers()}
      expandedRows={firstExpandedRows}
      rowExpansionTemplate={FirstCustomExpansionTemplate}
      dataKey="id"
      wrapperClassName={styles.mainTableWrapper}
    />
  )
}
export default ActivityCheckInDataTable
